var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardFilled = function SvgCreditCardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 10v6a5.007 5.007 0 0 1-5 5H5a5.007 5.007 0 0 1-5-5v-6zM5.5 14a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0-.001-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3a5.007 5.007 0 0 1 5 5H0a5.007 5.007 0 0 1 5-5z"
  })));
};
export default SvgCreditCardFilled;